import { Editor as TinyMCEEditor } from "tinymce/tinymce";

export const TINYMCE_GLOBAL_STYLES = {
  ".tox-tinymce-aux": { zIndex: 9999999 },
  ".tox.tox-tinymce.tox-fullscreen": { zIndex: 9999998 },
} as const;

export function registerToolbarOverflowClickOutside(editor: TinyMCEEditor): void {
  editor.on("init", () => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target.closest(".tox-tinymce") && !target.closest(".tox-tinymce-aux")) {
        if (editor.queryCommandState("ToggleToolbarDrawer")) {
          editor.execCommand("ToggleToolbarDrawer");
        }
      }
    };
    document.addEventListener("click", handleClick);
    editor.on("remove", () => document.removeEventListener("click", handleClick));
  });
}

export const BASE_PLUGINS = [
  "paste",
  "lists",
  "image",
  "code",
  "imagetools",
  "link",
  "template",
  "table",
  "fullscreen",
];

const TOOLBAR_COMMON =
  "undo redo | styleselect fontsizeselect fontselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | forecolor backcolor | link removeformat | code medialibrary fullscreen | table";

export const TOOLBAR_RICH = TOOLBAR_COMMON;
export const TOOLBAR_RICH_WITH_TEMPLATES = `${TOOLBAR_COMMON} | template`;
